export class LoadingIndicator{
	
	contentLoading = '<div class=\"c-loading-indicator\"><div class=\"c-loading-indicator__element\"><i class=\"c-loading-indicator__element__icon\"></i></div></div>';
	contentLoadingDark = '<div class=\"c-loading-indicator theme--primary\"><div class=\"c-loading-indicator__element\"><i class=\"c-loading-indicator__element__icon\"></i></div></div>';

}